// extracted by mini-css-extract-plugin
export var bannerHeadline = "h_D";
export var bannerItem = "h_G";
export var bannerList = "h_F";
export var bannerWrapper = "h_C";